<template>
  <CardModule class="mt-6" title="Eleven Cashless">
    <v-row class="mt-5">
      <v-col cols="12">
        <BaseTextField
          label="URL Eleven Cashless"
          placeholder="Insira a URL do Eleven Cashless"
          v-model="$loja_gerenciar.cadastro.cashless.url_cashless"
          type="text"
        >
        </BaseTextField>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Token Eleven Cashless"
          placeholder="Insira o token do Eleven Cashless"
          v-model="$loja_gerenciar.cadastro.cashless.token_cashless"
          type="text"
          :rules="isFill ? [rules.required] : []"
        >
        </BaseTextField>
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import mixins from "../../mixins";
const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-cashless",
  mixins: [LojasGerenciarMixins, formRules],
  data() {
    return {};
  },
  components: {
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
  },
  methods: {},
  computed: {
    isFill() {
      return this.$loja_gerenciar.cadastro.cashless.url_cashless;
    },
  },
};
</script>
